import React, { Component } from 'react';
import {Button,InputGroup,Input,InputGroupAddon,Modal,ModalBody,Row,Col} from 'reactstrap';
import Select from 'react-select';
import officeCreatedIcon from './../../../../assets/office_created_icon.svg';
import Actions from './../Actions/Actions';
import filter from 'lodash/filter';
import sortBy from 'lodash/sortBy';
import reverse from 'lodash/reverse';
import EmptyMap from './EmptyMap';
import TooltipDefinition from '../../../UI/TooltipDefinition/TooltipDefinition';

class MapColumns extends Component {

  componentWillUnmount() {
    console.log("unmounting..");
  }

  searchAndSort = () => {
    const {allDataMapping,searchedTerm,sortType} = this.props;
    let returnList = allDataMapping;
    if(sortType === 'a-z') {
      returnList = sortBy(allDataMapping,(o) => o.value);
    } else if(sortType === 'z-a') {
      returnList = reverse(sortBy(allDataMapping,(o) => o.value));
    } else if(sortType === 'mapped-first' && filter(allDataMapping,(o) => o.column).length > 0) {
      returnList = reverse(sortBy(allDataMapping,(o) => o.column));
    } else if(sortType === 'unmapped-first' && filter(allDataMapping,(o) => o.column).length > 0) {
      returnList = sortBy(allDataMapping,(o) => o.column);
    }
    if(searchedTerm.length === 0) {
      return returnList;
    }
    returnList = filter(returnList,(o) => o.value.toLowerCase().contains(searchedTerm.toLowerCase()));
    return returnList;
  }

  renderMapSelectOption = (option) => {
    let target = `${option.value}`;
    return (
      !option.definition ?
      <div className="w-100 kpi-option" >{option.label}</div>
       :<TooltipDefinition
        target={target}
        definition={option.definition}
        name={option.label}
        type="light"
        place="left"
        delayShow={500}
      />)
  }

  render() { 
    
    const {allDataMapping,sortType,mapOptions,type,mapSelectPlaceholder,optionTypeTxt,
      searchBarPlaceholder,mappingSubHeaderTxt,mappingTableHeader,searchedTerm} = this.props;
      console.log(this.props)
    return (
      <div>
        {
          allDataMapping.length === 0 ? <EmptyMap mapType={mapSelectPlaceholder}/>
          :
        <div>
          <div className="item-subheader">
            {mappingSubHeaderTxt}
          </div>
          <div className="row mt40">
            <div className="col-md-8 col-lg-8">
              <InputGroup style={{ height: "40px" }}>
                <Input 
                  className="toolkit-field" 
                  value={searchedTerm}
                  placeholder={searchBarPlaceholder} 
                  onChange={({ target }) => this.props.onSearchQueryChange(target)} />
                <InputGroupAddon addonType="append">
                  <Button className="color-DADADA border-color-C3C4C7" style={{height:'40px'}}>
                    <i style={{color:'#A5A6AC',padding:'9px 18px'}} className="flaticon-search"></i>
                  </Button>
                </InputGroupAddon>
              </InputGroup>
            </div>
            <div className="col-md-4 col-lg-4 search-box-dropdown">
              <Select clearable={false} searchable={false} value={sortType} simpleValue options={[{ value: "a-z", label: optionTypeTxt + " A-Z" }, { value: "z-a", label: optionTypeTxt + " Z-A" }, { value: "mapped-first", label: "Mapped --> Unmapped" }, { value: "unmapped-first", label: "Unmapped --> Mapped" }]} onChange={this.props.onSortChange} />
            </div>
          </div>
          <div className="data-mapping-table">
            <table className="table table-responsive-lg text-primary-color tool-list-font" 
              style={{borderTop:'0px'}}>
              <thead className='bottom-border-color'>
                <tr className="row font-weight-bold text-secondary">
                  <th className="border-none col-md-6 col-lg-6 ml20 data-mapping-table-header">
                    {mappingTableHeader} ({this.searchAndSort(allDataMapping).length})
                  </th>
                </tr>
              </thead>
              <tbody style={{maxHeight:'400px',overflowY:'auto',display:'block'}}>
              {
                this.searchAndSort(allDataMapping).map((data) => {
                  return(
                    <tr className="map-column-table row pl20 pr20" key={data.value}
                      style={{borderTop:'0',borderBottom: '1px solid #E7E7E9'}}>
                      <td className="col-md-6 col-lg-6">
                        {data.value}
                      </td>
                      <td className="col-md-2 col-lg-2 alert-icon-bg text-right">
                        {data.column ? (
                          <img src={officeCreatedIcon} />
                        ) : (
                          <span>(unmapped)</span>
                        )}
                      </td>
                      <td className="color-5099DE col-lg-4 col-md-4">
                        <Select className="map-table-dropdown" 
                           placeholder={mapSelectPlaceholder} 
                           value={data.column} 
                           optionRenderer={this.renderMapSelectOption}
                           clearable={false}  
                           options={mapOptions} 
                           valueKey="value" labelKey="label"
                           onChange={value => this.props.onRowMapped(data, value)} />
                      </td>
                    </tr>
                )})}
              </tbody>
            </table>
          </div>
        </div>
        }
        <Actions nextBtnTxt="Continue" nxtBtnIcon="flaticon-next" nextBtnAction={this.props.nextStep} {...this.props} />
      </div>
    )
  }
}
 
export default MapColumns;
